import React, { useCallback } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { IFilter, IFiltersForm } from '../components/TableAbstractSCN'
import { serializeFiltersPure } from '../utils/serialize-filters'

const FiltersControlContext = React.createContext<ReturnType<
  typeof useFilters
> | null>(null)

export const useFiltersContext = () => React.useContext(FiltersControlContext)!

export const FiltersControlProvider = ({
  children,
  ...filtersControl
}: { children: React.ReactNode } & ReturnType<typeof useFilters>) => {
  return (
    <FiltersControlContext.Provider value={filtersControl}>
      {children}
    </FiltersControlContext.Provider>
  )
}

export type FiltersControl = ReturnType<typeof useFilters>

export const useFilters = (
  props: {
    defaultValues?: Partial<IFiltersForm>
    columnsLiteralIds?: string[]
  } = {},
) => {
  const {
    setValue: setFilters,
    control,
    watch: filtersObserver,
    register: registerFilter,
  } = useForm<IFiltersForm>({
    defaultValues: props.defaultValues || {
      filters: [],
    },
  })

  const { append: onAddFilter, remove: onRemoveFilter } = useFieldArray({
    control,
    name: 'filters',
  })

  const fields = filtersObserver()

  const serializeFilters = useCallback(
    (input: IFilter[]) =>
      serializeFiltersPure(input, props.columnsLiteralIds || []),
    [props.columnsLiteralIds],
  )

  return {
    setFilters,
    onAddFilter,
    onRemoveFilter,
    filtersObserver,
    registerFilter,
    control,
    filters: filtersObserver('filters'),
    serializeFilters,
    fields,
  }
}
